import React, { useEffect } from "react";

export function EventNotFound() {
  useEffect(() => { document.title = "Will – Évènement introuvable"; }, []);
  return (
    <div style={{ minHeight:"100vh", background:"#F5F3FF", fontFamily:"DM Sans, sans-serif", display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
      <div style={{ textAlign:"center", maxWidth:420 }}>
        <div style={{ fontSize:48, marginBottom:16 }}>🔎</div>
        <div style={{ fontSize:24, fontWeight:700, color:"#1a1a2e", marginBottom:8 }}>Évènement introuvable</div>
        <div style={{ fontSize:14, color:"#6b6b80", marginBottom:20 }}>
          Vérifie le lien que tu as reçu — format attendu : <code>will-app.com/event/&lt;code-evenement&gt;</code>.
        </div>
        <a href="https://will-app.com/" style={{ color:"#7B2FFF", fontSize:14, fontWeight:600, textDecoration:"none" }}>
          ← Voir tous les évènements
        </a>
      </div>
    </div>
  );
}
